import React from "react";
import {IonReactRouter} from "@ionic/react-router";
import MainPage from "../pages/MainPage";
import AuthenticationLocalService from "../services/storage/localStorage/AuthenticationLocalService";
import LogIn from "../pages/utils/LogIn";

/**
 * Class allowing the right router to be used depending on the user connected.
 * Displays the connection if no one is registered.
 * @author Alizée Grand
 * @version 1.2
 * @creation 13/08/2021
 * @last_update 11/01/2022
 **/
class MainRouter extends React.Component {

    render() {

        return (
            <IonReactRouter>
                {
                    AuthenticationLocalService.isUserConnected() ? <MainPage/> : <LogIn/>
                }
            </IonReactRouter>
        );

    };

}

export default MainRouter;
